import { defineStyle } from '@chakra-ui/react';

export const containerRecipe = {
  baseStyle: defineStyle({
    maxWidth: '1440px',
    paddingInline: 2.5,
  }),
};
